export const SEARCH_PLACEHOLDER = "Sök namn eller typ";